import React, { useState } from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Collapsible "90 Day Summary" card chrome. Each feature supplies its own inner
// summary body as children (their data shapes differ).
const NinetyDaySummaryShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: '#fff',
        mb: 2,
        overflow: 'hidden',
      }}
    >
      <Box
        onClick={() => setOpen(prev => !prev)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 3,
          py: 1.5,
          cursor: 'pointer',
          transition: 'background-color 0.15s ease',
          '&:hover': { bgcolor: 'action.hover' },
        }}
      >
        <ExpandMoreIcon
          sx={{
            color: 'text.secondary',
            transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s ease',
          }}
        />
        <Typography variant="subtitle1" fontWeight={700}>
          90 Day Summary
        </Typography>
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ px: 3, pb: 3 }}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

export default NinetyDaySummaryShell;
